module.exports = __webpack_public_path__ + "static/img/12051C_1_R_20201121_fit.e3f0b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12051C_1_R_20201121_fit.png
// module id = 4V1C
// module chunks = 0